import { useMutation, useQueryClient } from '@tanstack/react-query';

// The restore WRITE («Restaurar entrega»), sibling of useConfirmDeliveryCollect. The enable fn is
// injected (DI, MSW-testable). retry: false — a WRITE that force-transitions state must never be
// silently re-sent. On success, invalidate the detail (so the card refetches the new collectable
// state, data-driven) AND the user-deliveries list by prefix — the hook does not know the userId, so
// the default exact: false matches every ['user-deliveries', *], keeping the list coherent when the
// agent returns to it.
export function useEnableDelivery(id: string, enableDelivery: (id: string) => Promise<void>) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => enableDelivery(id),
    retry: false,
    // Fire-and-forget: do NOT return the promise. Returning it makes TanStack await the refetch
    // before the mutation settles, which would hide the refetch skeleton the caller drives off the
    // query's own fetching state.
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['delivery-detail', id] });
      void queryClient.invalidateQueries({ queryKey: ['user-deliveries'] });
      // …and the same list reached from a building's tab: same rows, other entry point.
      void queryClient.invalidateQueries({ queryKey: ['location-deliveries'] });
      // …and the box log by PREFIX: it is keyed by BOX id (which this hook does not know), and it is
      // box-level history this write can extend, so a re-unfold revalidates.
      void queryClient.invalidateQueries({ queryKey: ['locker-log'] });
      // …and the box-status notice, by PREFIX and for the same reason: it is keyed by BOX id, which
      // this hook does not know, and a write can change the box's occupancy.
      void queryClient.invalidateQueries({ queryKey: ['box-status'] });
      // …and the lock codes, by PREFIX and for the third time the same reason: they are keyed by
      // LOCK id, which this hook does not know, and a write can end up moving a pointer — so the
      // carriles must not keep painting the sequence read before it.
      void queryClient.invalidateQueries({ queryKey: ['lock-codes'] });
    },
  });
}
